/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Mobility_TargetInputs */

const en_portal_goal_mobility_target = /** @type {(inputs: Portal_Goal_Mobility_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squatting without knee pain`)
};

const pl_portal_goal_mobility_target = /** @type {(inputs: Portal_Goal_Mobility_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przysiad bez bólu kolan`)
};

/**
* | output |
* | --- |
* | "Squatting without knee pain" |
*
* @param {Portal_Goal_Mobility_TargetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_mobility_target = /** @type {((inputs?: Portal_Goal_Mobility_TargetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Mobility_TargetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_mobility_target(inputs)
	return en_portal_goal_mobility_target(inputs)
});